import isUndefined from 'lodash/isUndefined';
import omit from 'lodash/omit';
import React, {Component} from 'react';
import Config from './index';

export default EnhancedComponent => {
    return class WithConfig extends Component {
        constructor() {
            super();

            this._isStateful = !isUndefined(EnhancedComponent.prototype.render);
        }

        render() {
            const allProps = {
                ...omit(Config, ['set']),
                ...this.props
            };

            if (this._isStateful) {
                allProps.ref = node => { this._wrappedInstance = node; };
            }

            return (
                <EnhancedComponent
                    {...allProps}
                />
            );
        }
    };
};
